import { render, staticRenderFns } from "./DeleteKeywordDialog.vue?vue&type=template&id=e30c0410&scoped=true&"
import script from "./DeleteKeywordDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteKeywordDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteKeywordDialog.vue?vue&type=style&index=0&id=e30c0410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30c0410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
